//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UMUM from  '../../library/umum.js'
import WILAYAH from  '../../library/getWilayah'
import uniqid from 'uniqid';
import FETCHING from  '../../library/fetching'



export default {
    data () {
        return { 
          FETCHING : FETCHING, 
          token : localStorage.token,  
          usersnya: localStorage,
          terbitkanSurat:false, 
          modal_y:false,
          modal_n:false,

          lihat_blue:false,
          lihat_red:false,

          option_status : [{id  : 0, uraian : 'Proses'}, {id  : 1, uraian : 'Diterima'}, {id  : 2, uraian : 'Dikembalikan'}],
            form: { 
              modul:'sk_kelahiran_aytdau',

              file_lampiran     :null,
              file_lampiranOld  :null,              

              m_provinsi : '74',
              m_kabupaten : '7405',
              m_kecamatan : '',
              m_desa_kelurahan : '', 

 

              nama_bayi: '',
              jenis_kelamin_bayi: '', 
              tempat_kelahiran_bayi:'',
              nama_hari:'',
              tgl_lahir_bayi:'',
              pukul:'',
              berat_bayi:'',
              panjang_bayi:'',
              
              nik_pelapor:'',
              nama_pelapor:'',
              umur_pelapor:'',
              pekerjaan_pelapor:'',
              provinsi_pelapor:'',
              kabupaten_pelapor:'',
              kecamatan_pelapor:'',
              des_kel_pelapor:'',
              alamat_pelapor:'',
              
              nik_saksi1:'',
              nama_saksi1:'',
              umur_saksi1:'',
              pekerjaan_saksi1:'',
              provinsi_saksi1:'',
              kabupaten_saksi1:'',
              kecamatan_saksi1:'',
              des_kel_saksi1:'',
              alamat_saksi1:'',
              
              nik_saksi2:'',
              nama_saksi2:'',
              umur_saksi2:'',
              pekerjaan_saksi2:'',
              provinsi_saksi2:'',
              kabupaten_saksi2:'',
              kecamatan_saksi2:'',
              des_kel_saksi2:'',
              alamat_saksi2:'', 
 

              status : 0,
              keterangan : 0,
              
              keterangan_deskel:'',
              keterangan_kecamatan:'',
              keterangan_kabupaten  :'',

              status_deskel:0,
              status_kecamatan:0,
              status_kabupaten  :0,
              
              createdAt_deskel:'',
              createdAt_kecamatan:'',
              createdAt_kabupaten  :'',             

              file_terbitan   : null,
              emailPemohon    : '',
              email_file      : null,
              email_fileOld   : '',
              email_from      : '',
              email_to        : '',
              email_subject   : '',
              email_html      : '',

              createdBy      : '',
            },


            shape: '', 
            current: 3,   
            list_anggota_keluarga:[],
            data: null,

            wilayah : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahIbu : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahAyah : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahPelapor : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahSaksi1 : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            },
            wilayahSaksi2 : {
              uraian_provinsi : '',
              kd_provinsi : '',
              uraian_kabupaten : '',
              kd_kabupaten : '',
              uraian_kecamatan : '',
              kd_kecamatan : '',
              uraian_desa_kelurahan : '',
              kd_desa_kelurahan : '',
            }, 

            list_data : [],
            list_data_kecamatan : [],
            list_data_kabupaten : [],

            page_limit : 5,
            page_first: 1,
            page_last: 0,
            cari_value: "",
            cek_load_data : true,
            UMUM : UMUM,        
            WILAYAH : WILAYAH, 

 
        }
    },
    methods: {
      getView : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN_AYTDAU + "view", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                createdBy : this.$store.state.lcProfile.id
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data = res_data.data;
                this.page_last = res_data.jmlData;  
                // console.log(res_data);
        });
      },            
      add_data(){ 

        this.$store.state.modal_loading = true;


        var formData = new FormData(); 
        formData.append("modul", this.form.modul);  

        formData.append("id", uniqid());  

        formData.append("m_provinsi", this.form.m_provinsi);
        formData.append("m_kabupaten", this.form.m_kabupaten);
        formData.append("m_kecamatan", this.form.m_kecamatan);
        formData.append("m_desa_kelurahan", this.form.m_desa_kelurahan);  

        formData.append("nama_bayi", this.form.nama_bayi);
        formData.append("jenis_kelamin_bayi", this.form.jenis_kelamin_bayi); 
        formData.append("tempat_kelahiran_bayi", this.form.tempat_kelahiran_bayi); 
        formData.append("nama_hari", this.form.nama_hari);
        formData.append("tgl_lahir_bayi", this.form.tgl_lahir_bayi);
        formData.append("pukul", this.form.pukul);  
        formData.append("berat_bayi", this.form.berat_bayi);
        formData.append("panjang_bayi", this.form.panjang_bayi);
        
        formData.append("nik_pelapor", this.form.nik_pelapor);
        formData.append("nama_pelapor", this.form.nama_pelapor);
        formData.append("umur_pelapor", this.form.umur_pelapor);
        formData.append("pekerjaan_pelapor", this.form.pekerjaan_pelapor);
        formData.append("provinsi_pelapor", this.form.provinsi_pelapor);
        formData.append("kabupaten_pelapor", this.form.kabupaten_pelapor);
        formData.append("kecamatan_pelapor", this.form.kecamatan_pelapor);
        formData.append("des_kel_pelapor", this.form.des_kel_pelapor);
        formData.append("alamat_pelapor", this.form.alamat_pelapor);

        formData.append("nik_saksi1", this.form.nik_saksi1);
        formData.append("nama_saksi1", this.form.nama_saksi1);
        formData.append("umur_saksi1", this.form.umur_saksi1);
        formData.append("pekerjaan_saksi1", this.form.pekerjaan_saksi1);
        formData.append("provinsi_saksi1", this.form.provinsi_saksi1);
        formData.append("kabupaten_saksi1", this.form.kabupaten_saksi1);
        formData.append("kecamatan_saksi1", this.form.kecamatan_saksi1);
        formData.append("des_kel_saksi1", this.form.des_kel_saksi1);
        formData.append("alamat_saksi1", this.form.alamat_saksi1);

        formData.append("nik_saksi2", this.form.nik_saksi2);
        formData.append("nama_saksi2", this.form.nama_saksi2);
        formData.append("umur_saksi2", this.form.umur_saksi2);
        formData.append("pekerjaan_saksi2", this.form.pekerjaan_saksi2);
        formData.append("provinsi_saksi2", this.form.provinsi_saksi2);
        formData.append("kabupaten_saksi2", this.form.kabupaten_saksi2);
        formData.append("kecamatan_saksi2", this.form.kecamatan_saksi2);
        formData.append("des_kel_saksi2", this.form.des_kel_saksi2);
        formData.append("alamat_saksi2", this.form.alamat_saksi2);


        formData.append("keterangan_deskel", this.form.keterangan_deskel);
        formData.append("keterangan_kecamatan", this.form.keterangan_kecamatan);
        formData.append("keterangan_kabupaten", this.form.keterangan_kabupaten);
        
        formData.append("status", this.form.status);
        formData.append("keterangan", this.form.keterangan);



        formData.append("createdAt", UMUM.NOW()); 
        formData.append("emailPemohon", this.form.emailPemohon);

        formData.append("file_lampiran", this.form.file_lampiran);


        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN_AYTDAU + "addData", {
            method: "POST",
            headers: {
                // "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
            }, 
            body: formData 
        }).then(res_data => { 
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_berhasil')
            this.getView();
            console.log(res_data);
        });
        
      },
      editData : function(){

        this.$store.state.modal_loading = true;


        var formData = new FormData(); 
        formData.append("modul", this.form.modul);  

        formData.append("id", this.form.id);

        formData.append("m_provinsi", this.form.m_provinsi);
        formData.append("m_kabupaten", this.form.m_kabupaten);
        formData.append("m_kecamatan", this.form.m_kecamatan);
        formData.append("m_desa_kelurahan", this.form.m_desa_kelurahan);  

        formData.append("nama_bayi", this.form.nama_bayi);
        formData.append("jenis_kelamin_bayi", this.form.jenis_kelamin_bayi); 
        formData.append("tempat_kelahiran_bayi", this.form.tempat_kelahiran_bayi); 
        formData.append("nama_hari", this.form.nama_hari);
        formData.append("tgl_lahir_bayi", this.form.tgl_lahir_bayi);
        formData.append("pukul", this.form.pukul);  
        formData.append("berat_bayi", this.form.berat_bayi);
        formData.append("panjang_bayi", this.form.panjang_bayi);
        
        formData.append("nik_pelapor", this.form.nik_pelapor);
        formData.append("nama_pelapor", this.form.nama_pelapor);
        formData.append("umur_pelapor", this.form.umur_pelapor);
        formData.append("pekerjaan_pelapor", this.form.pekerjaan_pelapor);
        formData.append("provinsi_pelapor", this.form.provinsi_pelapor);
        formData.append("kabupaten_pelapor", this.form.kabupaten_pelapor);
        formData.append("kecamatan_pelapor", this.form.kecamatan_pelapor);
        formData.append("des_kel_pelapor", this.form.des_kel_pelapor);
        formData.append("alamat_pelapor", this.form.alamat_pelapor);

        formData.append("nik_saksi1", this.form.nik_saksi1);
        formData.append("nama_saksi1", this.form.nama_saksi1);
        formData.append("umur_saksi1", this.form.umur_saksi1);
        formData.append("pekerjaan_saksi1", this.form.pekerjaan_saksi1);
        formData.append("provinsi_saksi1", this.form.provinsi_saksi1);
        formData.append("kabupaten_saksi1", this.form.kabupaten_saksi1);
        formData.append("kecamatan_saksi1", this.form.kecamatan_saksi1);
        formData.append("des_kel_saksi1", this.form.des_kel_saksi1);
        formData.append("alamat_saksi1", this.form.alamat_saksi1);

        formData.append("nik_saksi2", this.form.nik_saksi2);
        formData.append("nama_saksi2", this.form.nama_saksi2);
        formData.append("umur_saksi2", this.form.umur_saksi2);
        formData.append("pekerjaan_saksi2", this.form.pekerjaan_saksi2);
        formData.append("provinsi_saksi2", this.form.provinsi_saksi2);
        formData.append("kabupaten_saksi2", this.form.kabupaten_saksi2);
        formData.append("kecamatan_saksi2", this.form.kecamatan_saksi2);
        formData.append("des_kel_saksi2", this.form.des_kel_saksi2);
        formData.append("alamat_saksi2", this.form.alamat_saksi2);


        formData.append("keterangan_deskel", this.form.keterangan_deskel);
        formData.append("keterangan_kecamatan", this.form.keterangan_kecamatan);
        formData.append("keterangan_kabupaten", this.form.keterangan_kabupaten);
        
        formData.append("status", this.form.status);
        formData.append("keterangan", this.form.keterangan);


        formData.append("createdAt", UMUM.NOW()); 
        formData.append("file_lampiran", this.form.file_lampiran);

        formData.append("fileOld", this.fileOld);
     


        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN_AYTDAU + "editData", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData
        }).then(res_data => { 
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getView();
        });
      },          
      removeData : function(E){
        this.$store.state.modal_loading = true;

        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN_AYTDAU + "removeData", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                id : this.form.id,
                fileOld : this.fileOld,
                file_lampiran     : this.form.file_lampiran,
                file_lampiranOld  : this.form.file_lampiranOld,                
            })
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_berhasil_menghapus');
            this.getView();
        }); 
      }, 
      selectData : function(data){   
        console.log(data);

          this.form.id = data.permohonan_KELAHIRAN_aytdau.id;

          this.form.modul                         = data.permohonan_KELAHIRAN_aytdau.modul;
          this.form.m_provinsi                    = data.permohonan_KELAHIRAN_aytdau.m_provinsi;
          this.form.m_kabupaten                   = data.permohonan_KELAHIRAN_aytdau.m_kabupaten;
          this.form.m_kecamatan                   = data.permohonan_KELAHIRAN_aytdau.m_kecamatan;
          this.form.m_desa_kelurahan              = data.permohonan_KELAHIRAN_aytdau.m_desa_kelurahan;
          
          

          this.form.nama_bayi                     = data.permohonan_KELAHIRAN_aytdau.nama_bayi;
          this.form.jenis_kelamin_bayi            = data.permohonan_KELAHIRAN_aytdau.jenis_kelamin_bayi; 
          this.form.tempat_kelahiran_bayi         = data.permohonan_KELAHIRAN_aytdau.tempat_kelahiran_bayi;
          this.form.nama_hari                     = data.permohonan_KELAHIRAN_aytdau.nama_hari;
          this.form.tgl_lahir_bayi                = data.permohonan_KELAHIRAN_aytdau.tgl_lahir_bayi;
          this.form.pukul                         = data.permohonan_KELAHIRAN_aytdau.pukul;   
          this.form.berat_bayi                    = data.permohonan_KELAHIRAN_aytdau.berat_bayi;
          this.form.panjang_bayi                  = data.permohonan_KELAHIRAN_aytdau.panjang_bayi;

  
          this.form.nik_pelapor         = data.permohonan_KELAHIRAN_aytdau.nik_pelapor;
          this.form.nama_pelapor        = data.permohonan_KELAHIRAN_aytdau.nama_pelapor;
          this.form.umur_pelapor        = data.permohonan_KELAHIRAN_aytdau.umur_pelapor;
          this.form.pekerjaan_pelapor   = data.permohonan_KELAHIRAN_aytdau.pekerjaan_pelapor;
          this.form.provinsi_pelapor    = data.permohonan_KELAHIRAN_aytdau.provinsi_pelapor;
          this.form.kabupaten_pelapor   = data.permohonan_KELAHIRAN_aytdau.kabupaten_pelapor;
          this.form.kecamatan_pelapor   = data.permohonan_KELAHIRAN_aytdau.kecamatan_pelapor;
          this.form.des_kel_pelapor     = data.permohonan_KELAHIRAN_aytdau.des_kel_pelapor;
          this.form.alamat_pelapor      = data.permohonan_KELAHIRAN_aytdau.alamat_pelapor;

          this.form.nik_saksi1            = data.permohonan_KELAHIRAN_aytdau.nik_saksi1;
          this.form.nama_saksi1           = data.permohonan_KELAHIRAN_aytdau.nama_saksi1;
          this.form.umur_saksi1           = data.permohonan_KELAHIRAN_aytdau.umur_saksi1;
          this.form.pekerjaan_saksi1      = data.permohonan_KELAHIRAN_aytdau.pekerjaan_saksi1;
          this.form.provinsi_saksi1       = data.permohonan_KELAHIRAN_aytdau.provinsi_saksi1;
          this.form.kabupaten_saksi1      = data.permohonan_KELAHIRAN_aytdau.kabupaten_saksi1;
          this.form.kecamatan_saksi1      = data.permohonan_KELAHIRAN_aytdau.kecamatan_saksi1;
          this.form.des_kel_saksi1        = data.permohonan_KELAHIRAN_aytdau.des_kel_saksi1;
          this.form.alamat_saksi1         = data.permohonan_KELAHIRAN_aytdau.alamat_saksi1;

          this.form.nik_saksi2            = data.permohonan_KELAHIRAN_aytdau.nik_saksi2;
          this.form.nama_saksi2           = data.permohonan_KELAHIRAN_aytdau.nama_saksi2;
          this.form.umur_saksi2           = data.permohonan_KELAHIRAN_aytdau.umur_saksi2;
          this.form.pekerjaan_saksi2      = data.permohonan_KELAHIRAN_aytdau.pekerjaan_saksi2;
          this.form.provinsi_saksi2       = data.permohonan_KELAHIRAN_aytdau.provinsi_saksi2;
          this.form.kabupaten_saksi2      = data.permohonan_KELAHIRAN_aytdau.kabupaten_saksi2;
          this.form.kecamatan_saksi2      = data.permohonan_KELAHIRAN_aytdau.kecamatan_saksi2;
          this.form.des_kel_saksi2        = data.permohonan_KELAHIRAN_aytdau.des_kel_saksi2;
          this.form.alamat_saksi2         = data.permohonan_KELAHIRAN_aytdau.alamat_saksi2;

          this.form.keterangan_deskel     = data.permohonan_KELAHIRAN_aytdau.keterangan_deskel;
          this.form.keterangan_kecamatan  = data.permohonan_KELAHIRAN_aytdau.keterangan_kecamatan;
          this.form.keterangan_kabupaten  = data.permohonan_KELAHIRAN_aytdau.keterangan_kabupaten;
          this.form.status                = data.permohonan_KELAHIRAN_aytdau.status;
          this.form.keterangan            = data.permohonan_KELAHIRAN_aytdau.keterangan; 

          this.form.file_lampiran         = data.permohonan_KELAHIRAN_aytdau.file_lampiran; 
          this.form.file_lampiranOld      = data.permohonan_KELAHIRAN_aytdau.file_lampiranOld; 

          this.form.createdBy      = data.permohonan_KELAHIRAN_aytdau.createdBy; 

              
            
          // this.form.email_file    = data.permohonan_KTP.email_file;

          this.form.emailPemohon  = data.permohonan_KELAHIRAN_aytdau.emailPemohon;
          this.form.email_fileOld = data.permohonan_KELAHIRAN_aytdau.email_file;
          this.form.email_from    = this.form.email_from;
          this.form.email_to      = this.form.emailPemohon;
          this.form.email_subject = data.permohonan_KELAHIRAN_aytdau.email_subject;
          if (data.permohonan_KELAHIRAN_aytdau.email_html == undefined || data.permohonan_KELAHIRAN_aytdau.email_html == null || data.permohonan_KELAHIRAN_aytdau.email_html == '') {
            this.form.email_html    = ''
          } else {
            this.form.email_html    = data.permohonan_KELAHIRAN_aytdau.email_html; 
          }
          
          this.fileOld            = data.permohonan_KELAHIRAN_aytdau.file;
          this.fileOldThumb       = data.permohonan_KELAHIRAN_aytdau.fileThumb;          


        this.wilayah = {
          uraian_provinsi : data.m_provinsi.uraian,
          kd_provinsi : data.m_provinsi.kd_provinsi,
          uraian_kabupaten : data.m_kabupaten.uraian,
          kd_kabupaten : data.m_kabupaten.kd_kabupaten,
          uraian_kecamatan : data.m_kecamatan.uraian,
          kd_kecamatan : data.m_kecamatan.kd_kecamatan,
          uraian_desa_kelurahan : data.m_desa_kelurahan.uraian,
          kd_desa_kelurahan : data.m_desa_kelurahan.kd_desa_kelurahan,
        }; 


        this.wilayahPelapor = {
          uraian_provinsi       : data.wilayah_provinsi_pelapor.uraian,
          kd_provinsi           : data.wilayah_provinsi_pelapor.kd_provinsi,
          uraian_kabupaten      : data.wilayah_kabupaten_pelapor.uraian,
          kd_kabupaten          : data.wilayah_kabupaten_pelapor.kd_kabupaten,
          uraian_kecamatan      : data.wilayah_kecamatan_pelapor.uraian,
          kd_kecamatan          : data.wilayah_kecamatan_pelapor.kd_kecamatan,
          uraian_desa_kelurahan : data.wilayah_deskel_pelapor.uraian,
          kd_desa_kelurahan     : data.wilayah_deskel_pelapor.kd_desa_kelurahan,
        }; 
        this.wilayahSaksi1 = {
          uraian_provinsi       : data.wilayah_provinsi_saksi1.uraian,
          kd_provinsi           : data.wilayah_provinsi_saksi1.kd_provinsi,
          uraian_kabupaten      : data.wilayah_kabupaten_saksi1.uraian,
          kd_kabupaten          : data.wilayah_kabupaten_saksi1.kd_kabupaten,
          uraian_kecamatan      : data.wilayah_kecamatan_saksi1.uraian,
          kd_kecamatan          : data.wilayah_kecamatan_saksi1.kd_kecamatan,
          uraian_desa_kelurahan : data.wilayah_deskel_saksi1.uraian,
          kd_desa_kelurahan     : data.wilayah_deskel_saksi1.kd_desa_kelurahan,
        }; 
        this.wilayahSaksi2 = {
          uraian_provinsi       : data.wilayah_provinsi_saksi2.uraian,
          kd_provinsi           : data.wilayah_provinsi_saksi2.kd_provinsi,
          uraian_kabupaten      : data.wilayah_kabupaten_saksi2.uraian,
          kd_kabupaten          : data.wilayah_kabupaten_saksi2.kd_kabupaten,
          uraian_kecamatan      : data.wilayah_kecamatan_saksi2.uraian,
          kd_kecamatan          : data.wilayah_kecamatan_saksi2.kd_kecamatan,
          uraian_desa_kelurahan : data.wilayah_deskel_saksi2.uraian,
          kd_desa_kelurahan     : data.wilayah_deskel_saksi2.kd_desa_kelurahan,
        }; 
        // console.log(data.wilayah_provinsi_ibu.uraian);
        

      },
      clearData : function (){
              this.form.id                          = ''
              // this.form.modul                       = 'sk_kelahiran_aytdau'
              // this.form.m_provinsi                  = '74'
              // this.form.m_kabupaten                 = '7405'
              // this.form.m_kecamatan                 = ''
              // this.form.m_desa_kelurahan            = ''
              // this.form.nama_bayi                   = ''
              // this.form.jenis_kelamin_bayi          = ''
              // this.form.tempat_kelahiran_bayi       = ''
              // this.form.nama_hari                   = ''
              // this.form.tgl_lahir_bayi              = ''
              // this.form.pukul                       = ''
              // this.form.berat_bayi                  = ''
              // this.form.panjang_bayi                = ''
              // this.form.nik_pelapor                 = ''
              // this.form.nama_pelapor                = ''
              // this.form.umur_pelapor                = ''
              // this.form.pekerjaan_pelapor           = ''
              // this.form.provinsi_pelapor            = ''
              // this.form.kabupaten_pelapor           = ''
              // this.form.kecamatan_pelapor           = ''
              // this.form.des_kel_pelapor             = ''
              // this.form.alamat_pelapor              = ''
              // this.form.nik_saksi1                  = ''
              // this.form.nama_saksi1                 = ''
              // this.form.umur_saksi1                 = ''
              // this.form.pekerjaan_saksi1            = ''
              // this.form.provinsi_saksi1             = ''
              // this.form.kabupaten_saksi1            = ''
              // this.form.kecamatan_saksi1            = ''
              // this.form.des_kel_saksi1              = ''
              // this.form.alamat_saksi1               = ''
              // this.form.nik_saksi2                  = ''
              // this.form.nama_saksi2                 = ''
              // this.form.umur_saksi2                 = ''
              // this.form.pekerjaan_saksi2            = ''
              // this.form.provinsi_saksi2             = ''
              // this.form.kabupaten_saksi2            = ''
              // this.form.kecamatan_saksi2            = ''
              // this.form.des_kel_saksi2              = ''
              // this.form.alamat_saksi2               = ''
              // this.form.status                      = 0
              // this.form.keterangan                  = 0
              // this.form.keterangan_deskel           = ''
              // this.form.keterangan_kecamatan        = ''
              // this.form.keterangan_kabupaten        = ''
              // this.form.status_deskel               = 0
              // this.form.status_kecamatan            = 0
              // this.form.status_kabupaten            = 0
              // this.form.createdAt_deskel            = ''
              // this.form.createdAt_kecamatan         = ''
              // this.form.createdAt_kabupaten         = ''
              // this.form.file_terbitan               = null
              // this.form.emailPemohon                = ''
              // this.form.email_file                  = null
              // this.form.email_fileOld               = ''
              // this.form.email_from                  = ''
              // this.form.email_to                    = ''
              // this.form.email_subject               = ''
              // this.form.email_html                  = ''
              // this.form.email_html                  = ''

              // this.form.file_lampiran               = null
              // this.form.file_lampiranOld            = null
            
              // this.wilayah                          = ''
              // this.wilayahIbu                       = ''
              // this.wilayahAyah                      = ''
              // this.wilayahPelapor                   = ''
              // this.wilayahSaksi1                    = ''
              // this.wilayahSaksi2                    = ''

              
      },

    // ============================= KECAMATAN =============================
      getViewKecamatan : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN_AYTDAU + "viewKecamatan", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                status_kecamatan : this.form.status_kecamatan,
                pl_provinsi       :this.$store.state.lcProfile.provinsi,
                pl_kabupaten      :this.$store.state.lcProfile.kabupaten,
                pl_kecamatan      :this.$store.state.lcProfile.kecamatan,
            })
          })
            .then(res => res.json())
            .then(res_data => { 
                this.list_data_kecamatan = res_data.data;
                this.page_last = res_data.jmlData; 
                // console.log("INI KECAMATAN")
                console.log(res_data);
        });
      }, 

      editDataKecamatan : function(status){
        this.$store.state.modal_loading = true;

        // console.log(status)
        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN_AYTDAU + "editDataKecamatan", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              id : this.form.id,
              keterangan_kecamatan : this.form.keterangan_kecamatan,
              createdAt_kecamatan : UMUM.NOW(),
              kategorix : status
            })
        }).then(res_data => {
            this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getViewKecamatan();
        });
      },

    // ============================= KECAMATAN =============================

    // ============================= KABUPATEN =============================
      getViewKabupaten : function(){
        // this.$store.commit("shoWLoading");
        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN_AYTDAU + "viewKabupaten", {
            method: "POST",
            headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
                data_ke: this.page_first,
                page_limit : this.page_limit,
                cari_value: this.cari_value,
                status_kabupaten : this.form.status_kabupaten
            })
          })
            .then(res => res.json())
            .then(res_data => {
              // console.log("TAAAAAAAAAAIIIIIIII")
                this.list_data_kabupaten = res_data.data;
                this.page_last = res_data.jmlData;
                // this.$store.commit("hideLoading");
                console.log(res_data);
        });
      },
      editDataKabupaten : function(status){
        this.$store.state.modal_loading = true;

        console.log("SA DI CLICK")
        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN_AYTDAU + "editDataKabupaten", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              id : this.form.id,
              keterangan_kabupaten : this.form.keterangan_kabupaten,
              createdAt_kabupaten : UMUM.NOW(),
              kategorix : status
            })
        }).then(res_data => {
        this.$store.state.modal_loading = false;

            this.$store.commit('notif_edit');
            this.getViewKabupaten();
        });
      },
      terbit_file_Kabupaten : function(){
        this.$store.state.modal_loading = true;

        console.log(this.form.email_fileOld);
        var formData = new FormData();
        formData.append("id", this.form.id);
        formData.append("email_file", this.form.email_file); 
        formData.append("email_fileOld", this.form.email_fileOld); 
        formData.append("email_from", this.form.email_from)
        formData.append("email_to", this.form.email_to)
        formData.append("email_subject", this.form.email_subject) 
        formData.append("email_html", this.form.email_html)
        

        fetch(this.$store.state.url.URL_PERMOHONAN_KELAHIRAN_AYTDAU + "file_terbitan_Kabupaten", {
            method: "POST",
            headers: {
              // "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: formData,
        }).then(res_data => { 
            this.wa_notif()
            this.$store.state.modal_loading = false; 
            this.$store.commit('notif_terbit');
            this.getView();
        });
      },
      async wa_notif(){
          var data = await this.FETCHING.fetch_postx(this.$store.state.url.URL_WA_API+'send_wa' , JSON.stringify({
            createdBy : this.form.createdBy,
            pesan     : 'Surat Keterangan Kelahiran (Anak Yang Tidak Diketahui Asal-Usulnya)'
          }))
          console.log(data);
      },      
    // ============================= KABUPATEN =============================
      bukaTab(linknya){
        window.open(linknya);
      },
    // ====================================== filter autocomplete ======================================
        renderChildProv(data) {
            return `
            <span><b>${data.kd_provinsi}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChildKab(data) {
            return `
            <span><b>${data.kd_kabupaten}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChildKec(data) {
            return `
            <span><b>${data.kd_kecamatan}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        renderChild_des_kel(data) {
            return `
            <span><b>${data.kd_desa_kelurahan}</b></span>
            <span style='font-size:80%'>${data.uraian}</span>
            `
        },

        get_auto(data){ 
          this.form.m_provinsi = data.m_provinsi  
        },

        get_auto_kab(data){ 
          this.form.m_kabupaten = data.m_kabupaten  
        },

        get_auto_kec(data){ 
          this.form.m_kecamatan = data.m_kecamatan  
        },

        get_auto_des_kel(data){ 
          this.form.m_desa_kelurahan = data.m_desa_kelurahan 
        },        
        
        prov_pelapor(data){ 
          this.form.provinsi_pelapor = data.m_provinsi  
        }, 
        kab_pelapor(data){ 
          this.form.kabupaten_pelapor = data.m_kabupaten 
        },
        kec_pelapor(data){ 
          this.form.kecamatan_pelapor = data.m_kecamatan  
        },
        des_kel_pelapor(data){ 
          this.form.des_kel_pelapor = data.m_desa_kelurahan  
        },

        prov_saksi1(data){ 
          this.form.provinsi_saksi1 = data.m_provinsi  
        },
        kab_saksi1(data){ 
          this.form.kabupaten_saksi1 = data.m_kabupaten 
        },
        kec_saksi1(data){ 
          this.form.kecamatan_saksi1 = data.m_kecamatan  
        },
        des_kel_saksi1(data){ 
          this.form.des_kel_saksi1 = data.m_desa_kelurahan  
        },

        prov_saksi2(data){ 
          this.form.provinsi_saksi2 = data.m_provinsi  
        },
        kab_saksi2(data){ 
          this.form.kabupaten_saksi2 = data.m_kabupaten 
        },
        kec_saksi2(data){ 
          this.form.kecamatan_saksi2 = data.m_kecamatan  
        },
        des_kel_saksi2(data){ 
          this.form.des_kel_saksi2 = data.m_desa_kelurahan  
        },
    // ====================================== filter autocomplete ======================================      

      CariData(){
        
        if (this.$store.state.lcProfile.kelas == 'kecamatan') {
          this.getViewKecamatan()
        } else if (this.$store.state.lcProfile.kelas == 'kabupaten') {
          this.getViewKabupaten() 
        }else{
          this.getView();
        } 
      },
 

        cekButton_status_kecamatan: function(data){  
          var a = data.permohonan_KELAHIRAN_aytdau.status 
          var status_kab = data.permohonan_KELAHIRAN_aytdau.status_kabupaten  
          if (this.$store.state.lcProfile.kelas == 'op_vertikal') {
            if (status_kab == 1) {
              return true
            }
            return false
          }else{
            if (a == 1) {
              return true
            }else{
              return false
            }
          }  
        },
          

    },
    mounted(){
        this.CariData();
        this.getView();

        this.$store.state.lcProfile.kelas
        this.$store.state.lcProfile.id
        var email_from          = this.$store.state.lcProfile.email 
        var email_pemohon       = this.$store.state.lcProfile.email 
        this.form.emailPemohon  = email_pemohon
        this.form.email_from    = email_from 

        // console.log(this.$store.state.lcProfile);
        
      
    }
}
